module.exports = "/_next/static/images/game-1-phone-shatter-0a4604903be6199f585732478604d708.png";